import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Currency, IxfiCurrencyService, IxfiLanguageService, Language } from 'header';
import { forkJoin } from 'rxjs';
import { IntercomService } from './intercom.service';
import { Coin } from '../models/coin.model';
import { CoinService } from './coin.service';

export const AppResolver: ResolveFn<[Language[], Currency[], Coin[]]> = (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
) => {
    const intercomService = inject(IntercomService);
    const ixfiCoinsHttp$ = inject(CoinService).fetchIxfiCoins();
    const ixfiLanguagesHttp$ = inject(IxfiLanguageService).fetchLanguageList();
    const ixfiCurrenciesHttp$ = inject(IxfiCurrencyService).fetchCurrencyList();

    return forkJoin([ixfiLanguagesHttp$, ixfiCurrenciesHttp$, ixfiCoinsHttp$]);
};
